export const contactLensModelColumns = [
    {
        Header: 'Model Name',
        accessor: 'modelName',
        enableFilter: true
    },
    {
        Header: 'Manufacturer',
        accessor: row => row.manufacturer?.name || 'N/A',
        id: 'manufacturer',
        enableFilter: true
    },
    {
        Header: 'Material',
        accessor: row => row.material?.name || 'N/A',
        id: 'material'
    },
    {
        Header: 'Lens Type',
        accessor: 'lensType',
        enableFilter: true,
        Cell: ({ value }) => {
            const typeMap = {
                'single_vision': 'Single Vision',
                'bifocal': 'Bifocal',
                'multifocal': 'Multifocal',
                'toric': 'Toric',
                'spherical': 'Spherical'
            };
            return typeMap[value] || value;
        }
    },
    {
        Header: 'Trial',
        accessor: row => (row.isTrialAvailable ? `Yes${row.trialQuantity ? ` (${row.trialQuantity})` : ''}` : 'No'),
        id: 'trial',
        enableFilter: true,
        Cell: ({ value }) => {
            const isYes = value && value.startsWith('Yes');
            const color = isYes ? '#1976d2' : '#9e9e9e';
            return <span style={{ color, fontWeight: '600' }}>{value}</span>;
        }
    },

];
